// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3e0O3","right":"Footer_right__34DC4","buttons":"Footer_buttons__seQ2Y"};